import { DestinationWithStreamMeta } from '@anm/components/stream/StreamItem';
import { useSelector } from 'react-redux';
import { DestinationList, SocialDestination } from 'types/stream';

import useDestinationsList from '@anm/components/stream/destination_management/hooks/useDestinationList';
import { streamSelectors } from '../store/modules/stream';

const useMapStreamDestinations = (
  streamId?: string,
  streamDestinations?: DestinationWithStreamMeta[],
  ownerId?: string
) => {
  const [, allDestinations = []] = useDestinationsList();

  const guestsDestinations = useSelector(state => streamSelectors.selectGuestDestinations(state, streamId));

  const guestsArray = Object.keys(guestsDestinations || {}).map(
    key => guestsDestinations?.[key]
  ) as SocialDestination[];

  const destinations = [...allDestinations, ...(guestsArray || [])].reduce((acc, d) => {
    const streamDestination = streamDestinations?.find(s => s.id === d?.id);

    acc.push({
      ...d,
      title: d.title || guestsDestinations?.[d.id],
      request: streamDestination?.request,
      user_id:
        acc.some(s => s.id === d.id) &&
        streamDestinations?.some(s => s.id === d.id) &&
        allDestinations.some(s => s.id === d.id)
          ? ownerId
          : streamDestination?.user_id
    } as SocialDestination);

    return acc;
  }, [] as DestinationList);

  return [destinations, guestsDestinations] as const;
};

export default useMapStreamDestinations;
